import { Link, useLocation } from 'react-router-dom';
import { Search, LayoutDashboard, Bookmark, User, Menu } from 'lucide-react';
import { useState } from 'react';

const NAV_ITEMS = [
  { to: '/jobs', icon: Search, label: 'Jobs' },
  { to: '/dashboard', icon: LayoutDashboard, label: 'Home' },
  { to: '/saved-jobs', icon: Bookmark, label: 'Saved' },
  { to: '/profile', icon: User, label: 'Profile' },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);

  const MORE_ITEMS = [
    { to: '/blog', label: 'Blog' },
    { to: '/salary-calculator', label: 'Salary Calculator' },
    { to: '/tools', label: 'WFH Tools' },
    { to: '/equipment', label: 'Equipment' },
    { to: '/community', label: 'Community' },
    { to: '/hiring-events', label: 'Hiring Events' },
    { to: '/membership', label: 'Membership' },
    { to: '/support', label: 'Support' },
  ];

  return (
    <>
      {/* Spacer */}
      <div className="mobile-nav-spacer" />

      {/* More Menu Overlay */}
      {showMore && (
        <div className="fixed inset-0 z-[99] md:hidden" onClick={() => setShowMore(false)}>
          <div className="absolute inset-0 bg-black/30" />
          <div className="absolute bottom-[72px] left-4 right-4 bg-white dark:bg-[hsl(200,10%,14%)] rounded-2xl border border-[#E5E0D8] dark:border-[hsl(200,10%,20%)] shadow-[0_-8px_30px_rgb(0,0,0,0.15)] p-4" data-testid="mobile-more-menu" onClick={e => e.stopPropagation()}>
            <div className="grid grid-cols-2 gap-2">
              {MORE_ITEMS.map(item => (
                <Link key={item.to} to={item.to} onClick={() => setShowMore(false)}
                  className="px-4 py-3 rounded-xl text-sm text-[#1C2A24] dark:text-[hsl(40,20%,88%)] hover:bg-[#F4F1E8] dark:hover:bg-[hsl(200,10%,18%)] transition-colors" data-testid={`mobile-more-${item.label.toLowerCase().replace(/\s/g, '-')}`}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Bottom Nav Bar */}
      <nav className="fixed bottom-0 left-0 right-0 z-[100] md:hidden bg-white/90 dark:bg-[hsl(200,10%,10%)]/90 backdrop-blur-xl border-t border-[#E5E0D8] dark:border-[hsl(200,10%,20%)]" data-testid="mobile-bottom-nav">
        <div className="flex items-center justify-around h-[72px] px-2 safe-area-pb">
          {NAV_ITEMS.map(item => {
            const active = location.pathname === item.to;
            return (
              <Link key={item.to} to={item.to} className="flex flex-col items-center gap-1 min-w-[56px]" data-testid={`mobile-nav-${item.label.toLowerCase()}`}>
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${active ? 'bg-[#047857] shadow-[0_4px_12px_rgb(4,120,87,0.3)]' : ''}`}>
                  <item.icon size={18} className={active ? 'text-white' : 'text-[#1C2A24]/40 dark:text-[hsl(40,20%,50%)]'} strokeWidth={active ? 2 : 1.5} />
                </div>
                <span className={`text-[10px] ${active ? 'text-[#047857] font-medium' : 'text-[#1C2A24]/40 dark:text-[hsl(40,20%,50%)]'}`}>{item.label}</span>
              </Link>
            );
          })}
          <button onClick={() => setShowMore(!showMore)} className="flex flex-col items-center gap-1 min-w-[56px]" data-testid="mobile-nav-more">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${showMore ? 'bg-[#047857] shadow-[0_4px_12px_rgb(4,120,87,0.3)]' : ''}`}>
              <Menu size={18} className={showMore ? 'text-white' : 'text-[#1C2A24]/40 dark:text-[hsl(40,20%,50%)]'} strokeWidth={showMore ? 2 : 1.5} />
            </div>
            <span className={`text-[10px] ${showMore ? 'text-[#047857] font-medium' : 'text-[#1C2A24]/40 dark:text-[hsl(40,20%,50%)]'}`}>More</span>
          </button>
        </div>
      </nav>
    </>
  );
}
